import React from 'react';

import team from '../../../assets/images/meet-the-team.jpg';
import discord from '../../../assets/images/aboutpg_discord.svg';
import location from '../../../assets/images/aboutpg_location.svg';
import heart from '../../../assets/images/aboutpg_heart.svg';

const AboutUs = () => {
  return (
    <section className="about-metafans">
      <div className="px-5 md:px-10">
        <div className="flex flex-col md:flex-row items-center">
          <div className="w-full md:w-5/12 mr-3">
            <h1 className="lt-white font-bold mb-5 text-4xl lg:text-5xl tracking-tight">
              Meet the People behind the MetaFans Project
            </h1>
            <h2 className="text-grey font-bold mb-4 text-xl lg:text-2xl tracking-tight">
              Learn about our team.
            </h2>
          </div>
          <div className="w-full md:w-7/12">
            <img
              className="mx-auto"
              src={team}
              alt="meet the metafans team"
            ></img>
          </div>
        </div>
        <div className="flex flex-col-reverse md:flex-col">
          <div className="flex flex-col md:flex-row text-center md:text-left  items-center justify-center about-stats font-bold py-8 md:py-16 gap-5">
            <div className="flex flex-col md:flex-row items-center w-full md:w-1/3 justify-center md:justify-start items-center stat-item gap-2">
              <div>
                <img
                  className="w-[3rem] h-[3rem]"
                  src={discord}
                  alt="discord users"
                />
              </div>
              <div>
                <p className="text-grey text-base">Discord Users</p>
                <h2 className="lt-white font-bold text-4xl tracking-tight">
                  11.7k
                </h2>
              </div>
            </div>
            <div className="flex flex-col md:flex-row text-center md:text-left  items-center w-full md:w-1/3 justify-center md:justify-start items-center stat-item gap-2">
              <div>
                <img
                  className="w-[3rem] h-[3rem]"
                  src={location}
                  alt="event numbers"
                />
              </div>
              <div>
                <p className="text-grey text-base">Number Of Events</p>
                <h2 className="lt-white font-bold text-4xl tracking-tight">
                  120+
                </h2>
              </div>
            </div>
            <div className="flex flex-col md:flex-row text-center md:text-left items-center w-full md:w-1/3 justify-center md:justify-start items-center stat-item gap-2">
              <div>
                <img
                  className="w-[3rem] h-[3rem]"
                  src={heart}
                  alt="giving back"
                />
              </div>
              <div>
                <p className="text-grey text-base">
                  Prize Money Given to Holders
                </p>
                <h2 className="lt-white font-bold text-4xl tracking-tight">
                  $75k+
                </h2>
              </div>
            </div>
          </div>
          <div className="about-text">
            <p className="text-grey font-medium">
              Created with the love of sports at its core, MetaFans is the first
              NFT project of its kind, connecting sports fans with exclusive
              experiences. With a commitment to bringing people together, our
              mission is to provide unforgettable IRL experiences and give back
              to the community through our charity partnerships.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
